<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      eager
      scrollable
      max-width="1000px"
      content-class="rounded-dialog"
    >
      <v-form ref="SupportFunction" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="circle-add" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">
                    {{ action }} IPCR Support Function
                    {{
                      tab
                        ? tab == 1
                          ? "for Non-Teaching Personnels"
                          : "for Teaching Personnels"
                        : ""
                    }}
                  </div>

                  <div class="dialog-subtitle">
                    Fill in the required information below
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="closeD()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  v-if="action == 'Add' && moduleFrom != 'Employee'"
                >
                  <v-autocomplete
                    v-model="selectedType"
                    :rules="[formRules.required]"
                    outlined
                    label="Adding Type"
                    @change="changeType()"
                    class="rounded-lg"
                    item-text="description"
                    item-value="id"
                    color="#93CB5B"
                    :items="selectionList"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" v-if="selectedType == 2 && action == 'Add'">
                  <v-autocomplete
                    v-model="selectedPrevYear"
                    :rules="[formRules.required]"
                    outlined
                    label="Select Previous Year's Support Function to Replicate"
                    @change="setYear()"
                    class="rounded-lg"
                    item-text="year"
                    item-value="year"
                    color="#93CB5B"
                    :items="prevYear"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Year"
                    readonly
                    outlined
                    v-model="year"
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="func_type"
                    :rules="[formRules.required]"
                    @change="changeActualAccomp()"
                    outlined
                    label="Function Type"
                    class="rounded-lg"
                    item-text="description"
                    item-value="id"
                    color="#93CB5B"
                    :items="func_List"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col
                  cols="12"
                  v-if="
                    moduleFrom == 'Employee' &&
                    data &&
                    data.isFaculty == 1 &&
                    func_type == 3
                  "
                >
                  <v-autocomplete
                    v-model="faculty_sf_profDev_ID"
                    :rules="[formRules.required]"
                    dense
                    @change="setFacultySucInd()"
                    outlined
                    label="Please Select Professional and Development"
                    class="rounded-lg"
                    item-text="mfo"
                    item-value="id"
                    color="#93CB5B"
                    :items="profDevList"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" v-if="selectedType == 1">
                  <v-textarea
                    label="Success Indicator"
                    :disabled="moduleFrom == 'Employee'"
                    outlined
                    v-model="success_indicator"
                    dense
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" v-if="selectedType == 1">
                  <div
                    v-if="showInterveningFunctionNote.show"
                    class="text-caption blue--text"
                  >
                    {{ showInterveningFunctionNote.note }}
                  </div>
                  <v-textarea
                    label="Actual Accomplishment"
                    outlined
                    :disabled="moduleFrom != 'Employee'"
                    :rules="func_type != 2 ? [formRules.required] : []"
                    v-model="actual_accom"
                    dense
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" class="mt-4" v-if="selectedType == 1">
                  <div class="rating-card">
                    <div class="rating-header">
                      <div class="rating-title">
                        <v-icon size="18" color="#147452" class="mr-2">
                          mdi-star-outline
                        </v-icon>

                        <template v-if="data && data.isFaculty">
                          Rating Criteria
                        </template>
                        <template v-else> Rating Criteria </template>
                      </div>

                      <div
                        v-if="data && data.isFaculty"
                        class="rating-subtitle"
                      >
                        Checkboxes are auto-checked and cannot be changed.
                      </div>

                      <div v-else class="rating-subtitle">
                        Uncheck criteria that should not be included in the
                        evaluation.
                      </div>
                    </div>

                    <v-row class="mt-2">
                      <!-- Efficiency -->
                      <v-col cols="12" md="4">
                        <div
                          class="metric-card"
                          :class="{ active: eff_is_rated }"
                        >
                          <v-switch
                            v-model="eff_is_rated"
                            hide-details
                            class="metric-checkbox"
                            color="#147452"
                            :readonly="data && data.isFaculty == 1"
                          />

                          <div class="metric-content">
                            <div class="metric-code">E</div>
                            <div class="metric-title">Efficiency</div>
                          </div>
                        </div>
                      </v-col>

                      <!-- Quality -->
                      <v-col cols="12" md="4">
                        <div
                          class="metric-card"
                          :class="{ active: qly_is_rated }"
                        >
                          <v-switch
                            v-model="qly_is_rated"
                            hide-details
                            class="metric-checkbox"
                            color="#147452"
                            :readonly="data && data.isFaculty == 1"
                          />

                          <div class="metric-content">
                            <div class="metric-code">Q</div>
                            <div class="metric-title">Quality</div>
                          </div>
                        </div>
                      </v-col>

                      <!-- Timeliness -->
                      <v-col cols="12" md="4">
                        <div
                          class="metric-card"
                          :class="{ active: timeliness_is_rated }"
                        >
                          <v-switch
                            v-model="timeliness_is_rated"
                            hide-details
                            class="metric-checkbox"
                            color="#147452"
                            :readonly="data && data.isFaculty == 1"
                          />

                          <div class="metric-content">
                            <div class="metric-code">T</div>
                            <div class="metric-title">Timeliness</div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <!-- <v-col cols="12" class="mt-2 py-2 px-3" v-if="func_type != 1">
                  <div class="pa-2 rounded-lg" style="border: 1px solid grey">
                    <div class="text-h6 py-2">Attachment</div>

                    <v-btn
                      v-if="!getIsFileSelected && !isFileSaved"
                      color="#519043"
                      outlined
                      @click="showFileUpload()"
                      >Upload Attachment</v-btn
                    >
                    <v-btn
                      v-if="getIsFileSelected && isFileSaved"
                      color="#519043"
                      class="mx-1 white--text"
                      @click="viewFile()"
                      >View Attachment</v-btn
                    >

                    <v-btn
                      v-if="getIsFileSelected && isFileSaved"
                      class="mx-1"
                      color="warning"
                      @click="reupload()"
                      >Reupload File</v-btn
                    >
                  </div>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn class="btn-cancel" outlined @click="closeD()">
              Cancel
            </v-btn>

            <v-btn
              v-if="action == 'Add' && !hasInterveningFunction"
              :color="$vuetify.theme.themes.light.submitBtns"
              class="btn-save"
              @click="moduleFrom == 'Employee' ? addMySupFunc() : addnew()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              Save
            </v-btn>

            <v-btn
              v-if="action == 'Update'"
              :color="$vuetify.theme.themes.light.submitBtns"
              class="btn-save"
              @click="moduleFrom == 'Employee' ? updateMySupFunc() : update()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="fileUploadDialog"
      transition="dialog-bottom-transition"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <span>{{ uploadFileAction }} Attachment</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="fileUploadDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4">
          <v-form @submit.prevent ref="AttachmentFormref">
            <v-row>
              <v-col cols="12">
                <v-file-input
                  v-model="file_selected"
                  :rules="[formRules.required, formRules.isPDF]"
                  accept="application/pdf"
                  outlined
                  color="#6DB249"
                  dense
                  label="Upload file"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn outlined color="red" @click="fileUploadDialog = false"
            >Close</v-btn
          >

          <v-btn
            class="white--text"
            :color="$vuetify.theme.themes.light.submitBtns"
            @click="saveAttachment()"
            :disabled="isAttachmentBtnLoading"
            :loading="isAttachmentBtnLoading"
            >save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  components: {
    icon,
  },
  props: {
    data: null,
    target_type: null,
    ipcrID: null,
    action: null,
    moduleFrom: null,
    tab: null,
  },

  data() {
    return {
      id: null,
      hasInterveningFunction: false,
      func_type: null,
      success_indicator: null,
      eff_is_rated: true,
      qly_is_rated: true,
      actual_accom: null,
      timeliness_is_rated: true,
      dialog: false,
      isSubmitLoading: false,
      attachment: null,
      file_selected: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      func_List: [
        { id: 1, description: "Institutional Obligations" },
        { id: 2, description: "Intervening Function" },
        { id: 3, description: "Professional Development" },
      ],

      mfo: null,
      mfoDescription: null,
      selectionList: [
        { id: 1, description: "Create New" },
        { id: 2, description: "Replicate Previous Year's Support Function" },
      ],
      selectedType: null,
      year: null,
      prevYear: [],
      selectedPrevYear: null,
      faculty_sf_profDev_ID: null,
      profDevList: [],
      fileUploadDialog: false,
      uploadFileAction: null,
      isAttachmentBtnLoading: false,
      isFileSaved: false,
    };
  },
  computed: {
    getIsFileSelected() {
      let toReturn = false;
      // var submit = [];
      // var approval = [];

      if (this.func_type && this.func_type != 1) {
        if (this.file_selected) {
          toReturn = true;
        }
      }

      return toReturn;
    },
    filterYear() {
      return this.$store.getters.getFilterSelected;
    },
    showInterveningFunctionNote() {
      let toShow = false;
      let note = "";
      if (this.func_type == 2) {
        toShow = true;
        note = "Please enter all your Committee/s involved here.";
      } else if (this.func_type == 3) {
        if (this.data && this.data.isFaculty == 1) {
          toShow = true;
          note = "";
        }
      }
      return {
        show: toShow,
        note: note,
      };
    },

    getProfDevMFO() {
      let mfo;
      for (let i = 0; i < this.profDevList.length; i++) {
        if (this.profDevList[i].id == this.faculty_sf_profDev_ID) {
          mfo = this.profDevList[i];
        }
      }
      return mfo;
    },
  },
  watch: {
    data: {
      handler(data) {
        console.log("SSSSS", data);
        this.hasInterveningFunction = data.hasInterveningFunction
          ? data.hasInterveningFunction
          : false;
        this.isFileSaved = false;
        this.dialog = true;
        this.file_selected = null;
        this.func_List = [
          { id: 1, description: "Institutional Obligations" },
          { id: 2, description: "Intervening Function" },
          { id: 3, description: "Professional Development" },
        ];
        if (data.ipcrID) {
          this.ipcrID = data.ipcrID;
        }
        if (data.id) {
          this.id = data.id;

          this.func_type = parseInt(data.func_type);
          this.actual_accom = data.actual_accom;
          if (data.func_type == 1) {
            this.success_indicator = data.success_indicator;
          } else {
            this.success_indicator = data.suc_ind;
          }

          this.eff_is_rated = data.eff_is_rated;
          this.qly_is_rated = data.qly_is_rated;
          this.timeliness_is_rated = data.timeliness_is_rated;
        } else {
          this.id = null;
          this.selectedType = 1;
          if (this.moduleFrom == "Employee") {
            this.func_List.splice(0, 1);
            this.func_type = 2;
            if (data.isFaculty) {
              this.func_List.splice(0, 1);
              this.faculty_sf_profDev_ID = null;
              this.loadProfessionalDevelopment();
            } else {
              this.func_List.splice(1, 1);
            }
          } else {
            this.func_type = 1;
          }

          if (this.filterYear != "All") {
            this.year = this.filterYear;
          } else {
            let d = new Date();
            this.year = d.getFullYear();
          }
          this.changeActualAccomp();
          this.eff_is_rated = 1;
          this.qly_is_rated = 1;
          this.timeliness_is_rated = 1;
        }
      },

      deep: true,
    },
  },

  methods: {
    initialize() {},

    closeD() {
      this.eventHub.$emit("closeAddIPCRSupportUtilDialog", false);
      this.initialize();
      this.isSubmitLoading = false;
      this.dialog = false;
    },

    changeType() {
      if (this.selectedType == 1) {
        if (this.filterYear != "All") {
          this.year = this.filterYear;
        } else {
          let d = new Date();
          this.year = d.getFullYear();
        }
        if (this.moduleFrom != "Employee") {
          this.func_List = [
            { id: 1, description: "Institutional Obligations" },
          ];
        } else {
          this.func_List = [
            { id: 1, description: "Institutional Obligations" },
            { id: 2, description: "Intervening Function" },
            { id: 3, description: "Professional Development" },
          ];
        }
      } else {
        this.year = null;
        if (this.moduleFrom != "Employee") {
          this.func_List = [
            { id: 1, description: "Institutional Obligations" },
          ];
        } else {
          this.func_List = [
            { id: 1, description: "Institutional Obligations" },
            { id: 2, description: "Intervening Function" },
            { id: 3, description: "Professional Development" },
          ];
        }
        this.loadPrevYearOfSF();
      }
    },

    setYear() {
      this.year = parseInt(this.selectedPrevYear) + 1;
    },

    loadPrevYearOfSF() {
      this.axiosCall("/ipcr-support-util/getPrevYears/" + this.tab, "GET").then(
        (res) => {
          // console.log(res.data);
          this.prevYear = res.data;
        },
      );
    },

    loadProfessionalDevelopment() {
      this.axiosCall(
        "/ipcr-support-util/getFacultyStrategicUtilForSelectionBy?type=Professional Development&ipcrID=" +
          this.ipcrID,
        "GET",
      ).then((res) => {
        console.log("Prof vev loaded", res.data);
        this.profDevList = res.data;
      });
    },

    changeActualAccomp() {
      if (this.func_type == 1) {
        this.success_indicator = null;
        this.actual_accom = "Provided by the Human Resource Management Office";
      } else if (this.func_type == 2) {
        this.success_indicator = "Involved in Committee/s of the College";
        this.actual_accom = null;
      } else {
        this.loadProfessionalDevelopment();
        this.success_indicator = null;
        this.actual_accom = null;
      }
    },

    setFacultySucInd() {
      if (this.faculty_sf_profDev_ID) {
        this.success_indicator = this.getProfDevMFO.mfo;
        this.eff_is_rated = this.getProfDevMFO.eff_is_rated;
        this.qly_is_rated = this.getProfDevMFO.qly_is_rated;
        this.timeliness_is_rated = this.getProfDevMFO.timeliness_is_rated;
      }
    },

    showFileUpload() {
      this.file_selected = null;
      this.fileUploadDialog = true;
      this.uploadFileAction = "Add";
    },
    reupload() {
      this.file_selected = null;
      this.fileUploadDialog = true;
      this.uploadFileAction = "Update";
    },

    viewFile() {
      const objectURL = URL.createObjectURL(this.file_selected);
      window.open(objectURL, "_blank");
    },

    saveAttachment() {
      this.isAttachmentBtnLoading = true;

      if (this.$refs.AttachmentFormref.validate()) {
        this.isFileSaved = true;
        this.isAttachmentBtnLoading = false;
        this.fileUploadDialog = false;
      }
    },

    addnew() {
      if (this.$refs.SupportFunction.validate()) {
        this.isSubmitLoading = true;
        let data = {
          selectedType: this.selectedType,
          year: this.year,
          selectedPrevYear:
            this.selectedType == 2 ? this.selectedPrevYear : null,
          success_indicator: this.success_indicator,
          actual_accom: this.actual_accom,
          func_type: this.func_type,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
          sf_for: this.tab == 1 ? "non-teaching" : "teaching",
        };
        // console.log(data);
        this.axiosCall("/ipcr-support-util", "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;

            this.closeD();
          } else {
            this.isSubmitLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },

    addMySupFunc() {
      if (this.$refs.SupportFunction.validate()) {
        // if (this.getIsFileSelected) {
        this.isSubmitLoading = true;
        let data = {
          ipcrID: this.ipcrID,
          suc_ind: this.success_indicator,
          actual_accom: this.actual_accom,
          func_type: this.func_type,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
          faculty_sf_profDev_ID: this.data.isFaculty
            ? this.faculty_sf_profDev_ID
            : null,
        };
        // let fd = new FormData();
        // fd.append("data", JSON.stringify(data));
        // fd.append("file", this.file_selected);
        console.log(data);
        // this.axiosCall("/ipcr-support/addSupportFunction", "POST", fd).then(
        this.axiosCall("/ipcr-support/addSupportFunction", "POST", data).then(
          (res) => {
            if (res.data.status == 201) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;

              this.closeD();
            } else {
              this.isSubmitLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          },
        );
        // } else {
        //   this.isSubmitLoading = false;
        //   this.fadeAwayMessage.show = true;
        //   this.fadeAwayMessage.type = "error";
        //   this.fadeAwayMessage.header = "System Message";
        //   this.fadeAwayMessage.message = "Attachment is required!.";
        // }
      } else {
        this.isSubmitLoading = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please fill in all required fields.";
      }
    },

    update() {
      if (this.$refs.SupportFunction.validate()) {
        this.isSubmitLoading = true;
        let data = {
          success_indicator: this.success_indicator,
          actual_accom: this.actual_accom,
          func_type: this.func_type,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
        };
        // console.log(data);
        this.axiosCall("/ipcr-support-util/" + this.id, "PATCH", data).then(
          (res) => {
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          },
        );
      }
    },

    updateMySupFunc() {
      if (this.$refs.SupportFunction.validate()) {
        this.isSubmitLoading = true;
        let data = {
          suc_ind: this.success_indicator,
          actual_accom: this.actual_accom,
          func_type: this.func_type,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
        };
        // console.log(data);
        this.axiosCall(
          "/ipcr-support/updateSupportFunction" + this.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },

    getEmpDetails() {
      this.axiosCall("/employee/my-details", "GET").then((res) => {
        console.log(res.data);
        this.assigned_office = res.data.officeID;
      });
    },

    getOffices() {
      this.axiosCall("/offices", "GET").then((res) => {
        this.officeList = res.data;
      });
    },

    getDesignations() {
      this.axiosCall("/designations", "GET").then((res) => {
        this.designationList = res.data;
      });
    },
  },
};
</script>
